import { useLocationStore } from "../state/storeLocation";
import { useTimeTableMonth } from "../state/storeTimeTable";
import { useTranslationStore } from "../state/useTranslationStore";
import useFormatDataLocale from "./translate/useFormatDataLocale";
import { useMonth } from "./useMonth";
import { useRamadanCalendar } from "./useRamadanCalendar";

type Prayer = {
  asr_begins: string;
  asr_iqamah: string;
  className: string;
  currentDate: string;
  date: string;
  dhuhr_begins: string;
  dhuhr_iqamah: string;
  fajr_begins: string;
  fajr_iqamah: string;
  fajr_masjid_jamaah: string;
  isha_begins: string;
  isha_iqamah: string;
  maghrib_begins: string;
  maghrib_iqamah: string;
  midnight: string;
  sunrise: string;
  today: string;
};

export const useMonthCalendar = (): Prayer[] => {
  const { MonthList } = useMonth();
  const { isLocaleRamadan } = useRamadanCalendar();
  const { month } = useLocationStore();
  const { TimeTableMonthFullYear } = useTimeTableMonth() as unknown as { TimeTableMonthFullYear: Prayer[] };
  const { gregorian_numbers, gregorian_months,activeLanguage,hijralocales } = useTranslationStore();
  const {gregorian_format} = useFormatDataLocale()
  if (!TimeTableMonthFullYear.length) return []; // Early return if empty
  
  // Ensure MonthList().value exists before accessing it
  const monthList = MonthList || [];
  const selectedMonth = monthList.find((date) => Number(date.method) === Number(month?.method));
  
  if (!selectedMonth) return []; // Handle case where month is not found

  
  // Filter the month data
  const calendar = TimeTableMonthFullYear.filter((date: any) => {
    const currentYear = new Date().getFullYear();
    const dateObj = new Date(date.date);
    const dateYear = dateObj.getFullYear();
    const dateMonth = dateObj.getMonth() + 1;
    const newDate = `${currentYear}-${dateMonth}-${dateObj.getDate()}`;
    
    if (Number(selectedMonth.method) === 13 && dateYear === currentYear && isLocaleRamadan({ currentDate: newDate })) {
      // Handle case where Ramadan extends into the next Gregorian year
      // console.log("🚀 ~ returnTimeTableMonthFullYear.filter ~ dateYear:", dateYear,"newDate: ",newDate)
      return true;
    }

    return dateYear === currentYear && dateMonth === Number(selectedMonth.method);
  }) as Prayer[];


  if(hijralocales.customLan){

    return gregorian_format(calendar,gregorian_numbers,gregorian_months,activeLanguage);
  } else {

    return calendar;
  }

};
